import formatNumberCommas from 'Utils/formatNumberCommas'
import clsx from 'clsx'

interface Props {
	idx: number
	active: boolean
	planImg: string
	planName: string
	planPrice: string
	planDescription: string
	onClick: (idx: number) => void
}

const ClickablePlanCard: React.FC<Props> = ({
	idx,
	active,
	planImg,
	planName,
	planPrice,
	planDescription,
	onClick,
}) => {
	const activeClassName =
		'border-kumopack-secondary-700 text-kumopack-secondary-700 bg-kumopack-secondary-50 border-2px'
	const inactiveClassName =
		'border-kumopack-grey-200 text-kumopack-grey-600 bg-kumopack-base-white border-2px'

	return (
		<div
			className={clsx('card p-4 border-radius-12px transition-100 cursor-pointer', {
				[activeClassName]: active,
				[inactiveClassName]: !active,
			})}
			onClick={() => onClick(idx)}>
			<div className="row gy-5">
				<div className="col-12 col-xl-1">
					<div className="d-flex flex-row align-items-center" style={{ gap: '12px' }}>
						<div className="d-flex justify-content-center align-items-center w-30px h-30px rounded-circle bg-kumopack-secondary-100">
							<img src={planImg} alt={planName} />
						</div>

						<div className="d-block d-xl-none">
							<div
								className={clsx('d-inline-block me-1 fw-bold', {
									'text-kumopack-secondary-800': active,
									'text-kumopack-grey-700': !active,
								})}>
								{planName}
							</div>
							<div className="d-inline-block">
								{formatNumberCommas(parseFloat(planPrice))}/month
							</div>
						</div>
					</div>
				</div>
				<div className="col-12 col-xl-11">
					<div className="d-none d-xl-block">
						<div
							className={clsx('d-inline-block me-1 fw-bold', {
								'text-kumopack-secondary-800': active,
								'text-kumopack-grey-700': !active,
							})}>
							{planName}
						</div>
						<div className="d-inline-block">{formatNumberCommas(parseFloat(planPrice))}/month</div>
					</div>
					<div>{planDescription}</div>
				</div>
			</div>
		</div>
	)
}

export default ClickablePlanCard
